module.exports = __webpack_public_path__ + "static/media/id3.ab37371d.jpg";